import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IoniconsOutline, WorkspaceInfo} from '@pt/pt-models';

@Component({
  selector: 'pt-attachments-workspace-breadcrumb',
  template: `
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb breadcrumb-custom'>
        <li class='breadcrumb-item mb-1'>
          <span class='btn btn-link btn-sm' (click)='clickRoot()'>
            <pt-icon [key]='IconHome'></pt-icon>
          </span>
        </li>
        <li class='breadcrumb-item' *ngFor='let folder of path; let last = last'>
          <span (click)='openFolder.emit(folder)'
                class='btn btn-link btn-sm ps-0 pe-0'>
            {{folder.label}}
          </span>
        </li>
      </ol>
    </nav>
  `,
  styles: [`
    .breadcrumb-custom {
      line-height: 2;
      margin-bottom: 0;
      padding: 0;
      background: transparent;
      border-radius: 0;
    }
  `]
})
export class AttachmentsWorkspaceBreadcrumbComponent {
  @Input() path: WorkspaceInfo[];

  @Output() openFolder = new EventEmitter<WorkspaceInfo>();

  IconHome = IoniconsOutline.home;

  clickRoot() {
    this.openFolder.emit({
      label: null,
      parentId: -1,
      id: -1
    });
  }
}
